import { Component, forwardRef } from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";
import { AnexoTipo, AnexoTipoLabels } from "src/app/types/AnexoTipoType";

@Component({
  selector: 'app-anexo-tipo',
  templateUrl: './anexo-tipo.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AnexoTipoComponent),
      multi: true
    }
  ]
})
export class AnexoTipoComponent implements ControlValueAccessor {

  readonly tipos = Object.entries(AnexoTipoLabels).map(([value, label]) => ({
    value: Number(value) as AnexoTipo,
    label
  }));

  value: AnexoTipo | null = null;

  onChange = (value: AnexoTipo | null) => { };
  onTouched = () => { };

  writeValue(value: AnexoTipo | null): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onInternalChange(value: AnexoTipo) {
    this.value = value;
    this.onChange(value);
    this.onTouched();
  }
}
